import { render } from "./update-delivery-form-table-stt.vue?vue&type=template&id=492c9a3c&ts=true"
import script from "./update-delivery-form-table-stt.vue?vue&type=script&lang=ts"
export * from "./update-delivery-form-table-stt.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__